import { render, staticRenderFns } from "./CardStyle2.vue?vue&type=template&id=9aeed1ea&scoped=true&"
import script from "./CardStyle2.vue?vue&type=script&lang=js&"
export * from "./CardStyle2.vue?vue&type=script&lang=js&"
import style0 from "./CardStyle2.vue?vue&type=style&index=0&id=9aeed1ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aeed1ea",
  null
  
)

export default component.exports